module.exports = __webpack_public_path__ + "static/media/header.48e99380.jfif";